import _debounce from 'lodash/debounce';
import Component from 'component';

class Header extends Component {
  constructor(el, config) {
    super(el, config);
  }

  setupDefaults() {
    this.dom = {
      $headerSearch: this.$el.find('.header-search'),
      $searchTrigger: this.$el.find('.header-search__trigger'),
      $mainContent: $('#mainContent'),
      $menuTrigger: this.$el.find('.header-menu__trigger'),
      $primaryNav: this.$el.find('.primary-nav'),
      $primaryNavItems: this.$el.find('.primary-nav__item')
    };
  }

  addListeners() {
    this.dom.$searchTrigger.on('touchstart click', ::this.onSearchTrigger);
  }

  onSearchTrigger(e) {
    e.stopPropagation();
    e.preventDefault();
    this.toggleHeaderSearch();
  }

  toggleHeaderSearch() {
    this.dom.$searchTrigger.toggleClass('is-active');

    if (!this.$el.hasClass('is-search-active')){
      Promise.resolve(this.$el.addClass('is-search-active')).then(() => {
        this.dom.$headerSearch.addClass('is-active');
        if (this.dom.$primaryNav.hasClass('open')){
          slideUp(this.dom.$primaryNav);
          this.dom.$primaryNav.removeClass('open');
          this.dom.$menuTrigger.removeClass('is-active');
          $('html').removeClass('has-menu-active');
          $('.parent-nav').removeClass('open');
        }
      });
    } else {
      Promise.resolve(this.dom.$headerSearch.removeClass('is-active')).then(() => {
        setTimeout(() => {
          this.$el.removeClass('is-search-active');
          this.dom.$menuTrigger.show('fast');
        }, 230);
      });
    }
    function slideUp(element) {
      const height = $(element).prop('scrollHeight');
      $(element).css('height', `${height}px`);
      setTimeout(() => {
        $(element).css('height', '0');
        $(element).removeClass('open');
      }, 0);
    }

  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/pg/js/components/Header.js